import { render, staticRenderFns } from "./material-detail.vue?vue&type=template&id=61400f5a&scoped=true&"
import script from "./material-detail.vue?vue&type=script&lang=js&"
export * from "./material-detail.vue?vue&type=script&lang=js&"
import style0 from "./material-detail.vue?vue&type=style&index=0&id=61400f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61400f5a",
  null
  
)

export default component.exports